import { memo } from 'react';
import MyLoaderIos from './MyLoaderIos';
import checkOs from '@/helpers/checkOs';
import '@/assets/styles/my-loader.scss';

interface MyLoaderProps {
    className?: string;
    width?: number;
    strokeWidth?: number;
    color?: string;
}

export default memo(function MyLoader({
    className = '',
    width = 40,
    strokeWidth = 3,
    color
}: MyLoaderProps) {
    // if (checkOs() === 'mac' || checkOs() === 'ios')
    //     return <MyLoaderIos className={className} width={width} color={color} />;

    return (
        <svg className={`circular ${className}`} width={width} height={width} viewBox="25 25 50 50">
            <circle
                className="path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                strokeWidth={strokeWidth}
                strokeMiterlimit="10"
                stroke={color || 'currentColor'}
            />
        </svg>
    );
});
